<template>
    <article class="rounded-lg shadow-lg overflow-hidden bg-highlight-5 border-2 border-highlight-20">
        <div class="relative h-0 card-overlay overflow-hidden" style="padding-bottom: calc(2.5/5*100%);">
            <img :src="pack.background_image" alt="Pack background">
        </div>
        <div class="px-4 pb-4 -mt-20 relative">
            <div class="flex flex-col my-4">
                <h2 class="text-highlight-100 font-bold uppercase leading-none mb-2">{{ plan.name }}</h2>
                <h3 class="text-sm text-highlight-100 font-medium leading-none">
                    <template>
                        <span class="text-2xl font-bold">
                            {{ price(plan) }}
                        </span>
                        <span>/ {{ plan.period }}</span>
                    </template>
                </h3>
            </div>
            <ul v-if="pack.feature_list !== null && pack.feature_list.length" class="mb-4">
                <li
                    v-for="(feature, index) in pack.feature_list"
                    :key="index"
                    class="flex items-center mb-2 text-highlight-100 leading-none"
                >
                    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"
                         class="fill-current text-accent mr-3">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M16.7071 5.29289C17.0976 5.68342 17.0976 6.31658 16.7071 6.70711L8.70711 14.7071C8.31658 15.0976 7.68342 15.0976 7.29289 14.7071L3.29289 10.7071C2.90237 10.3166 2.90237 9.68342 3.29289 9.29289C3.68342 8.90237 4.31658 8.90237 4.70711 9.29289L8 12.5858L15.2929 5.29289C15.6834 4.90237 16.3166 4.90237 16.7071 5.29289Z"/>
                    </svg>
                    {{ feature }}
                </li>
            </ul>

            <BaseAccordion>
                <template slot="toggle">
                    <BaseButton @click.native="$emit('selected', pack.uuid)">
                        {{ _(getButtonLabel(plan)) }}
                    </BaseButton>
                </template>
                <div class="text-center">
                    <hr class="block w-48 mx-auto mb-6 border-highlight-40">
                    <h3 class="mb-2 font-bold text-highlight-100 leading-tight">{{ pack.features_title }}</h3>
                    <p class="mb-6 text-sm text-highlight-60">{{ pack.features_subtitle }}</p>
                    <img :src="pack.features_image" :alt="pack.features_title" class="mb-6 rounded mx-auto">
                </div>
                <hr class="block w-48 mx-auto mb-6 border-highlight-40">
            </BaseAccordion>
        </div>
    </article>
</template>

<script>
import { mapGetters } from 'vuex'
import BaseAccordion from '@/components/Base/BaseAccordion.vue'
import BaseButton from '@/components/Base/BaseButton.vue'

export default {
    name: 'PlanCard',
    components: {
        BaseAccordion,
        BaseButton,
    },
    props: {
        pack: Object,
        plan: Object,
    },
    computed: {
        ...mapGetters({
            _: 'localisation/translate',
            price: 'packs/price',
        }),
    },
    methods: {
        getButtonLabel(plan) {
            return plan.trial_period !== null && plan.trial > 0
                ? 'pack_card_button_trial'
                : 'pack_card_button'
        },
    },
}
</script>

<style scoped>
    .card-overlay:after {
        content: "";
        position: absolute;
        bottom: 0;
        height: 100%;
        width: 100%;
    }
</style>
